import { Injectable } from '@angular/core';
import { UserSettings, ValueType } from '@deprecated/api-interfaces';
import { PrecisionBaseService } from '@ird/shared-utils';
import { TenantService } from './tenant.service';
import { UserService } from './user.service';

@Injectable()
export class PrecisionService extends PrecisionBaseService {
  constructor(
    private userService: UserService,
    private tenantService: TenantService,
  ) {
    super();
  }

  async convert(_query: { value: number; valueType?: ValueType; sourceUnit?: string; sensorPrecision?: number }): Promise<number> {
    const { value, valueType, sourceUnit, sensorPrecision } = _query;

    if (typeof value !== 'number') {
      return undefined;
    }

    if (valueType && sourceUnit) {
      const basePrecision = await this.loadPrecision(valueType, sourceUnit);

      // If sensorPrecision is defined, add it to basePrecision, if not use only basePrecision
      // Resulting precision is basePrecision(from tenant) + sensorPrecision(from SensorType)
      const precision = sensorPrecision ? +basePrecision + +sensorPrecision : basePrecision;
      return this.applyPrecision(value, precision);
    }
    return this.applyPrecision(value, sensorPrecision);
  }

  convertSync(_query: { value: number; sensorPrecision?: number }): number {
    const { value, sensorPrecision } = _query;

    if (typeof value !== 'number') {
      return undefined;
    }
    return this.applyPrecision(value, sensorPrecision);
  }

  private async loadPrecision(valueType: ValueType, sourceUnit?: string): Promise<number | undefined> {
    const userSettings = await this.userService.getUserSettings();
    const tenantSettings = this.tenantService.getTenantSettings();

    if (PrecisionService.userSettingsValid(userSettings)) {
      return this.findPrecision(userSettings?.dataConversions, tenantSettings?.precisions, valueType, sourceUnit);
    }
    return undefined;
  }

  private static userSettingsValid(userSettings: UserSettings): boolean {
    return !(!userSettings || !userSettings?.dataConversions);
  }
}
